import { render, staticRenderFns } from "./changeInfo.vue?vue&type=template&id=27b7a0d2"
import script from "./changeInfo.vue?vue&type=script&lang=ts"
export * from "./changeInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports